import { Component, OnInit } from '@angular/core';
import { BsModalRef } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';

@Component({
  selector: 'app-operation-success-modal',
  templateUrl: './operation-success-modal.component.html',
  styleUrls: ['./operation-success-modal.component.scss'],
})
export class OperationSuccessModalComponent implements OnInit {
  successful: boolean = true;

  title: string = 'Operación finalizada';
  submit: Subject<any>;

  constructor(private modalRef: BsModalRef) {
    this.submit = new Subject();
  }

  ngOnInit(): void { }

  close() {
    this.submit.next('closed');
    this.modalRef.hide();
  }
}
